var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{attrs:{"separator":_vm.separator,"separator-class":_vm.separatorClass}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }